import styled from "styled-components";
import { CONTENT_WIDTH, media } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto;
  margin-top: 100px;
  box-sizing: border-box;
  padding: 0 16px;

  ${media.downTablet`
    margin-top: 32px;
  `}

  ${media.downMobile`
    margin-top: 24px;
    padding: 0 12px;
  `}
`;

export const InnerContainer = styled.div`
  display: flex;
  gap: 50px;

  ${media.downTablet`
    flex-direction: column;
    gap: 32px;
  `}
`;

export const LeftCol = styled.div`
  width: 60%;

  ${media.downTablet`
    width: 100%;
  `}
`;

export const RightCol = styled.div`
  width: 40%;

  ${media.downTablet`
    width: 100%;
  `}
`;

export const MainHeading = styled.h2`
  margin: 0;
  padding-bottom: 50px;
  color: var(--Text2, #000);
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  ${media.downTablet`
    padding-bottom: 24px;
    font-size: 20px;
  `}
`;
